import { gql } from 'graphql-request'

export const GET_BASKET_BY_ID = gql`
  query getBasketById($id: bigint!) {
    baskets(where: { id: { _eq: $id } }) {
      id
      country_billing
      created_at
      first_field_billing
      second_field_billing
      phone_number_billing
      street_billing
      street_number_billing
      city_billing
      post_code_billing
      user_id
      promo_code
      nip
      baskets_delivery_addresses {
        basket {
          id
          city_billing
          country_billing
          created_at
          first_field_billing
          nip
        }

        delivery_address {
          id
          city
          country
          first_name
          house_and_flat_number
          id
          last_name
          phone_number
          post_code
          street_name
        }
      }

      orders {
        orders_products {
          product {
            id
            slug
            name
            cover: main_photo_url
            created_at
            duration: duration_of_event
            type
            status
            embedded_link
            tags
            orders_count
            bestseller
            newness
            creator {
              id
              slug
              nickname
              avatar: avatar_link
            }
            orders_products {
              order {
                price_subunit
              }
            }
            categories: product_categories {
              id: product_category_id
              category: product_category {
                id
                name
              }
            }

            entries: product_contest_entries {
              id
              name
              price {
                value: price_subunit
                currency: price_currency
              }
            }

            price {
              currency: price_currency
              value: price_subunit
              price_before_discount: price_before_discount_subunit
            }
          }
        }
      }
    }
  }
`
